const en = {
  app: {
    name: "Khan Baba",
    tagline: "Sweets & Restaurant",
  },
  nav: {
    menu: "Menu",
    daily: "Today's Fresh",
    cart: "Cart",
    admin: "Admin",
  },
  common: {
    add: "Add",
    added: "Added",
    remove: "Remove",
    soldOut: "Sold out",
    lowStock: "Only {{count}} left",
    remaining: "{{count}} left",
    back: "Back",
    next: "Next",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    loading: "Loading…",
    search: "Search dishes…",
    all: "All",
    km: "km",
    minToOrder: "Min order",
    each: "each",
    qty: "Qty",
    viewCart: "View cart",
    items: "items",
    fast: "Fast",
    minutes: "min",
    popular: "Popular",
  },
  home: {
    heroTitle: "Authentic flavours, delivered across Kuwait",
    heroSubtitle:
      "Chinese, sea food, biryani, fresh daily trays and sweets — from our Salmiya & Fahaheel kitchens to your door.",
    orderNow: "Order now",
    todaysFresh: "Today's fresh trays",
    fullMenu: "Full menu",
    dailyNote: "Cooked in bulk twice a day — limited quantity, first come first served.",
    branches: "Our branches",
    callUs: "Call",
    whatsapp: "WhatsApp",
    fastTitle: "Need it fast?",
    fastNote: "Order only ⚡ Fast items and get your delivery in about half the time.",
  },
  location: {
    title: "Where should we deliver?",
    subtitle: "Pick your branch and drop a pin so we can check the area and delivery fee.",
    chooseBranch: "Choose branch",
    autoNearest: "Nearest branch",
    byArea: "My area",
    byPin: "Map pin",
    pinOnMap: "Tap the map to drop a pin",
    useMyLocation: "Use my location",
    orPickArea: "or pick your area from the list",
    selectArea: "Select your area",
    distanceLabel: "Distance from {{branch}}",
    deliveryFee: "Delivery fee",
    outsideArea: "Sorry — this location is outside {{branch}}'s delivery area (max {{max}} km).",
    tryOtherBranch: "Try the other branch",
    confirm: "Confirm location",
    change: "Change",
    deliverTo: "Deliver to",
    feeVaries: "Fee depends on distance and order size — never free.",
    delivery: "Delivery",
    pickup: "Pickup",
    pickupFrom: "Pick up from",
    pickupNote: "Collect from the branch — no delivery fee.",
  },
  menu: {
    standingTitle: "Menu",
    dailyTitle: "Today's fresh trays",
    dailyTag: "Daily",
    madeToOrder: "Made to order",
    emptyDaily: "Today's fresh menu isn't published yet. Check back soon.",
    session: { morning: "Morning batch", evening: "Evening batch" },
  },
  cart: {
    title: "Your order",
    empty: "Your cart is empty.",
    browse: "Browse the menu",
    subtotal: "Subtotal",
    deliveryFee: "Delivery fee",
    total: "Total",
    belowMin: "Add {{amount}} more to reach the {{min}} minimum order.",
    setLocation: "Set your delivery location to see the fee.",
    checkout: "Checkout",
    outsideArea: "Your location is outside the delivery area.",
    eta: "Est. delivery",
    discount: "Discount",
  },
  promo: {
    title: "Promo code",
    placeholder: "Promo code",
    apply: "Apply",
    remove: "Remove",
    invalid: "That code isn't valid.",
    expired: "That code has expired.",
    belowMin: "Spend {{min}} to use this code.",
    noLongerValid: "Code {{code}} no longer applies to this order.",
    note: "Discounts apply to the order total only — delivery is never free.",
  },
  schedule: {
    title: "When?",
    asap: "ASAP",
    later: "Schedule",
    noSlots: "No more slots that day — pick another.",
    scheduledFor: "Scheduled for {{time}}",
    asapLabel: "As soon as possible",
    slotPassed: "That time has passed — please pick a new slot.",
  },
  checkout: {
    title: "Checkout",
    contact: "Contact details",
    name: "Full name",
    phone: "Phone number",
    addressTitle: "Delivery address",
    governorate: "Governorate",
    area: "Area",
    block: "Block",
    street: "Street",
    building: "Building / House",
    jadda: "Jadda / Avenue (optional)",
    floor: "Floor (optional)",
    apartment: "Apartment (optional)",
    paci: "PACI no. (optional)",
    notes: "Notes for the driver (optional)",
    payment: "Payment method",
    knet: "KNET",
    card: "Visa / Mastercard",
    applepay: "Apple Pay",
    cod: "Cash on delivery",
    online: "Pay online (KNET / cards / Apple Pay)",
    placeOrder: "Place order",
    paying: "Redirecting to secure payment…",
    placing: "Placing your order…",
    required: "Please fill in the required fields.",
    eta: "Estimated delivery",
    pickupEta: "Ready for pickup in",
    fastEta: "⚡ Fast delivery — about half the usual time",
    newAddress: "New address",
    saveAddress: "Save this address to my account",
    addressLabel: "Label (e.g. Home, Work)",
  },
  confirmation: {
    title: "Order placed!",
    thanks: "Thank you, {{name}}. We've received your order.",
    orderNo: "Order number",
    payNow: "Pay now",
    codNote: "Please have the cash ready for the driver.",
    statusNote: "The restaurant will call you shortly to confirm.",
    newOrder: "Place another order",
  },
  admin: {
    title: "Staff admin",
    signIn: "Sign in",
    signOut: "Sign out",
    email: "Email",
    password: "Password",
    daily: "Daily menu",
    standing: "Standing menu",
    orders: "Orders",
    branch: "Branch",
    publishMorning: "Publish morning batch",
    startEvening: "Start evening batch",
    published: "Published",
    addSpecial: "Add today's special",
    scan: "Scan menu board",
    scanning: "Reading photo…",
    scanNone: "Couldn't read items — try a clearer photo or add them manually.",
    scanAdded: "Added {{count}} items from the photo. Review, adjust and publish.",
    scanDemo:
      "Added {{count}} items (basic on-device scan). The live site uses AI vision for higher accuracy.",
    fast: "Fast",
    itemName: "Item (EN)",
    itemNameAr: "Item (AR)",
    price: "Price",
    qty: "Qty",
    active: "Active",
    saved: "Saved",
    ordersEmpty: "No orders yet.",
    status: {
      new: "New",
      confirmed: "Confirmed",
      preparing: "Preparing",
      out_for_delivery: "Out for delivery",
      delivered: "Delivered",
      cancelled: "Cancelled",
    },
    pay: {
      unpaid: "Unpaid",
      pending: "Pending",
      paid: "Paid",
      failed: "Failed",
      refunded: "Refunded",
    },
    demoNote: "Demo mode — no backend connected. Changes are local to this browser.",
  },
  demo: {
    banner: "Demo preview — sample data, no live backend.",
  },
  sheet: {
    notes: "Special instructions",
    notesPh: "e.g. extra spicy, no onions…",
    add: "Add to cart",
    required: "Required",
    optional: "Optional",
    upTo: "Up to {{n}}",
  },
  track: {
    title: "Track your order",
    subtitle: "Watch your order status update live.",
    enterId: "Order number (e.g. KB123456)",
    find: "Track order",
    notFound: "We couldn't find that order — check the number and try again.",
    cancelled: "This order was cancelled.",
    eta: "Estimated arrival",
    help: "Questions? Call or WhatsApp the branch.",
    recent: "Your recent orders",
    received: "Order received",
    preparing: "Preparing your food",
    onway: "On the way",
    delivered: "Delivered",
  },
  account: {
    title: "My account",
    signInTitle: "Sign in or create an account",
    signInBody: "Save your details for faster checkout and to see your order history. Optional — you can always order as a guest.",
    signIn: "Sign in",
    signOut: "Sign out",
    orders: "My orders",
    noOrders: "No orders yet.",
    guestNote: "No account needed to order — sign-in is optional.",
    savedAddress: "Saved address",
    addresses: "Saved addresses",
    addAddress: "Add address",
    noAddresses: "No saved addresses yet.",
    reorder: "Reorder",
  },
  reviews: {
    title: "What our customers say",
    count: "{{count}} reviews",
    leave: "Leave a review",
    yourName: "Your name",
    yourReview: "Your review",
    rate: "Your rating",
    submit: "Submit review",
    thanks: "Thanks for your review!",
  },
  footer: {
    tagline: "Freshly cooked sweets & meals, delivered across Kuwait.",
    hours: "Open daily",
    directions: "Directions",
    call: "Call",
    orderNow: "Order now",
    rights: "All rights reserved.",
  },
} as const;

export default en;
